/**
 * Viewer-Sync: hält pro User im aktuellen Projekt einen Snapshot von
 * Kamera-Zustand + 3D-Cursor-Position; verwaltet den Follow-Mode.
 */

import { create } from 'zustand'

export interface CameraState {
  position: [number, number, number]
  target: [number, number, number]
  yaw?: number
  pitch?: number
  radius?: number
}

export interface RemoteViewerState {
  userId: string
  username?: string
  camera?: CameraState
  cursor?: [number, number, number] | null
  ts: number
}

interface ViewerSyncStore {
  states: Record<string, RemoteViewerState>
  followingUserId: string | null
  setFollowing: (id: string | null) => void
  updateState: (userId: string, patch: Partial<RemoteViewerState>) => void
  removeUser: (userId: string) => void
  clear: () => void
}

export const useViewerSyncStore = create<ViewerSyncStore>((set) => ({
  states: {},
  followingUserId: null,
  setFollowing: (id) => set({ followingUserId: id }),
  updateState: (userId, patch) =>
    set((s) => ({
      states: {
        ...s.states,
        [userId]: { ...(s.states[userId] || { userId, ts: 0 }), ...patch, userId, ts: Date.now() },
      },
    })),
  removeUser: (userId) =>
    set((s) => {
      if (!s.states[userId]) return s
      const next = { ...s.states }
      delete next[userId]
      return {
        states: next,
        followingUserId: s.followingUserId === userId ? null : s.followingUserId,
      }
    }),
  clear: () => set({ states: {}, followingUserId: null }),
}))
